import JobApplicationPreview from './JobApplicationPreview.page';

export default JobApplicationPreview;
